import React from "react";
import styled from "styled-components";
import Products from "./Products";

const ProductsPage = () => {
  return (
    <Container>
      <Products />
    </Container>
  );
};
const Container = styled.div`
  margin-top: 10em;
  @media (max-width: 500px) {
    margin-top: 6em;
  }
`;

export default ProductsPage;
